import React, { Component } from 'react';
import PropTypes from 'prop-types';

class GeckoRow extends Component {
  render() {
    return this.props.hideWhen && this.props.hideWhen() ? null : (
      <div className="row">{this.props.children}</div>
    );
  }
}

GeckoRow.propTypes = {
  hideWhen: PropTypes.func,
};

export default GeckoRow;
